import { loadResourceFiles, uploadResourceFile } from '@/core/migration/supportMigrationFunctions'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { initDataInBoolean } from '@/core/item_assistance/initializeComponentData'
import { getDataFromBoolean } from '@/core/item_assistance/receiveDataFromComponents'

export function EditImportConfigManager (companyId) {
	this.global = !companyId

	this.editableMigration = {}
	this.migrationConfig = {}
	this.tagId = null

	this.setEditableMigration = function (migration) {
		this.editableMigration = migration
		if (!_.has(this.editableMigration, 'parameters')) {
			this.editableMigration.parameters = {}
		}
	}

	this.renderImportExcelTemplate = function () {
		$('.xslt-file_select').css('display', 'block')
		this.renderImportSample('excel', '.xlsx,.xls')
	}

	this.renderImportXmlTemplate = function () {
		$('.xslt-file_select').css('display', 'block')
		this.renderImportSample('xml', '.xml')
	}

	this.renderImportCsvTemplate = function () {
		$('.csv-format-list').css('display', 'block')
		if (this.editableMigration.parameters.csvFormat) {
			$('#csv-format-list').val(this.editableMigration.parameters.csvFormat)
		}

		$('.string-value_1').css('display', 'block')
		$('#string-value-1_label').text(getLocalizedMessage('encoding'))
		$('#string-value-1').attr('placeholder', 'utf-8')
		if (this.editableMigration.parameters.encoding) {
			$('#string-value-1').val(this.editableMigration.parameters.encoding)
		}

		$('.xslt-file_select').css('display', 'block')

		this.renderImportSample('csv', '.csv')
	}

	this.renderImportZipTemplate = function () {
		$('.string-value_1').css('display', 'block')
		$('#string-value-1_label').text(getLocalizedMessage('file.name.token.delimiter'))
		$('#string-value-1').attr('placeholder', '#')
		if (this.editableMigration.parameters.fileNameTokenDelimiter) {
			$('#string-value-1').val(this.editableMigration.parameters.fileNameTokenDelimiter)
		}

		$('.string-value_2').css('display', 'block')
		$('#string-value-2_label').text(getLocalizedMessage('hash.code.delimiter'))
		$('#string-value-2').attr('placeholder', '&')
		if (this.editableMigration.parameters.hashCodeDelimiter) {
			$('#string-value-2').val(this.editableMigration.parameters.hashCodeDelimiter)
		}

		this.renderImportSample('zip', '.zip')
	}

	this.renderImportSample = function (type, accept) {
		var manager = this

		$('.file-input_importSample').css('display', 'block')

		var importSample
		if (this.editableMigration.parameters && this.editableMigration.parameters.importSample) {
			importSample = this.editableMigration.parameters.importSample
		}
		loadResourceFiles($('#import-sample'), type, true, !this.global, importSample)

		var importSampleInputSelector = $('#import-sample-input')
		importSampleInputSelector.attr('accept', accept)

		importSampleInputSelector.unbind('change')
		importSampleInputSelector.change(function () {
			var file = importSampleInputSelector.get(0).files[0]
			importSampleInputSelector.val('')
			if (file == null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#import-sample'), type, true, !manager.global, name)
			})
		})

		var importSampleButtonSelector = $('#import-sample-button')
		importSampleButtonSelector.unbind('click')
		importSampleButtonSelector.click(function () {
			importSampleInputSelector.click()
		})
	}

	this.initEditMigrationForm = function (table) {
		var manager = this

		Swal.fire({
			title: getLocalizedMessage('edit.configuration'),
			html: '<div class="modal_item">\n' +
				'    <div class="new-migration_name">\n' +
				'        <label id="migration-name_label" for="migration-name">' + getLocalizedMessage('configuration.name') + '</label>\n' +
				'        <br>\n' +
				'        <input id="migration-name" type="text" class="textInput attribute-editor">\n' +
				'        <button class="button_reset fa fa-times"></button>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'     <div id="new-migration_action" class="new-migration_action">\n' +
				'        <label id="migration-action_label" for="migration-action">' + getLocalizedMessage('configuration.action') + '</label>\n' +
				'        <br>\n' +
				'            <select id="migration-action" class="select attribute-editor">\n' +
				'                <option value="CREATE_AND_UPDATE">' + getLocalizedMessage('migration.action.create.and.update') + '</option>\n' +
				'                <option value="CREATE_NEW">' + getLocalizedMessage('migration.action.create.new') + '</option>\n' +
				'                <option value="UPDATE_EXISTS">' + getLocalizedMessage('migration.action.update.exists') + '</option>\n' +
				'            </select>\n' +
				'      </div>\n' +
				'</div>' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_transformation-type">\n' +
				'        <label id="transformation-type_label" for="transformation-type">' + getLocalizedMessage('transformation.type') + '</label>\n' +
				'        <br>\n' +
				'        <select id="transformation-type" class="select attribute-editor">\n' +
				'            <option value=""></option>\n' +
				'        </select>\n' +
				'    </div>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <div class="new-migration_parameters migration-paramters">\n' +
				'        <br>\n' +
				'        <label id="migration-parameters" style="display: none">' + getLocalizedMessage('migration.parameters') + '</label>\n' +
				'        <div id="migration-debug-mode" style="display: none">\n' +
				'            <label for="debug-mode">' + getLocalizedMessage('debug.mode') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="debug-mode">\n' +
				'        </div>\n' +
				'        <div id="migration-update-null-fields-only" class="modal_item" style="display: none">\n' +
				'            <label for="update-null-fields-only">' + getLocalizedMessage('update.null.fields.only') + '</label>\n' +
				'            <input type="checkbox" class="checkbox-bool" id="update-null-fields-only">\n' +
				'        </div>\n' +
				'\n' +
				'        <div class="csv-format-list modal_item" style="display: none">\n' +
				'            <label id="csv-format-list_label" for="csv-format-list">' + getLocalizedMessage('csv.format.list') + '</label>\n' +
				'            <br>\n' +
				'            <select id="csv-format-list" class="select attribute-editor">\n' +
				'                <option value="default">default</option>\n' +
				'                <option value="excel">excel</option>\n' +
				'                <option value="excel_semicolon">excel_semicolon</option>\n' +
				'                <option value="mysql">mysql</option>\n' +
				'                <option value="rfc4180">rfc4180</option>\n' +
				'                <option value="tdf">tdf</option>\n' +
				'            </select>\n' +
				'        </div>\n' +
				'        <div class="xslt-file_select modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('xslt.file') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="xslt-file" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="xslt-file-input" class="attribute-editor" type="file" accept=".xsl" style="display:none;"/>\n' +
				'                <button id="xslt-file-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'        <div class="excel-template-sample modal_item" style="display: none">\n' +
				'            <a href="' + window.urlContext + 'export-config/excel/template">' + getLocalizedMessage('migration.excel.template.sample') + '</a>\n' +
				'        </div>\n' +
				'        <div class="string-value_1 modal_item" style="display: none">\n' +
				'            <label id="string-value-1_label" for="string-value-1"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-1" type="text" class="textInput attribute-editor modal_item">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="string-value_2 modal_item" style="display: none">\n' +
				'            <label id="string-value-2_label" for="string-value-2"></label>\n' +
				'            <br>\n' +
				'            <input id="string-value-2" type="text" class="textInput attribute-editor modal_item">\n' +
				'            <button class="button_reset fa fa-times"></button>\n' +
				'        </div>\n' +
				'        <div class="file-input_importSample modal_item" style="display: none">\n' +
				'            <label>' + getLocalizedMessage('import.sample') + '</label>\n' +
				'            <div class="modal_item">\n' +
				'                <select id="import-sample" class="select select-with-add attribute-editor"></select>\n' +
				'                <input id="import-sample-input" class="attribute-editor" type="file" style="display:none;"/>\n' +
				'                <button id="import-sample-button" class="button_plus fa fa-plus" tabindex="-1"></button>\n' +
				'            </div>\n' +
				'        </div>\n' +
				'    </div>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				$('#transformation-type').attr('disabled', 'disabled')
				manager.bindAddResourceButtons()

				var xsltForSelect
				if (manager.editableMigration.parameters.xslt) {
					xsltForSelect = manager.editableMigration.parameters.xslt[0]
				}
				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global, xsltForSelect)

				manager.initSelectedParameters()
				bindResetButtonModal()
			},
			preConfirm: function (inputValue) {
				manager.getEditMigrationParameters()
			}
		}).then(function (result) {
			if (result.value) {
				manager.updateMigration(table)
			}
		})
	}

	this.bindAddResourceButtons = function () {
		var manager = this

		var xsltFileInputSelector = $('#xslt-file-input')
		xsltFileInputSelector.unbind('change')
		xsltFileInputSelector.change(function () {
			var file = xsltFileInputSelector.get(0).files[0]
			xsltFileInputSelector.val('')
			if (file === null) {
				return
			}

			uploadResourceFile(manager.global, file, function (data) {
				var name = data['name']
				if (manager.global) {
					name = 'global/' + name
				}
				loadResourceFiles($('#xslt-file'), 'xslt', true, !manager.global, name)
			})
		})

		var xsltFileButtonSelector = $('#xslt-file-button')
		xsltFileButtonSelector.unbind('click')
		xsltFileButtonSelector.click(function () {
			xsltFileInputSelector.click()
		})
	}

	this.initSelectedParameters = function () {
		if (this.editableMigration.parameters) {
			if (this.editableMigration.parameters.xslt) {
				$('#xslt-file').val(this.editableMigration.parameters.xslt[0])
			}
			if (this.editableMigration.parameters.requiredFieldsOnly) {
				initDataInBoolean('required-fields-only', this.editableMigration.parameters.requiredFieldsOnly)
			}
			initDataInBoolean('debug-mode', this.editableMigration.parameters.debug)
			initDataInBoolean('update-null-fields-only', this.editableMigration.parameters.updateNullFieldsOnly)
		}
	}

	this.renderEditMigrationParameters = function () {
		$('#migration-parameters').css('display', 'block')
		$('#migration-debug-mode').css('display', 'block')
		$('#migration-update-null-fields-only').css('display', 'block')

		$('#migration-name').val(this.editableMigration['name'])

		var migrationActionSelector = $('#migration-action')
		migrationActionSelector.val('').change()
		migrationActionSelector.val(this.editableMigration['action']).change()

		var transformationTypeSelector = $('#transformation-type')
		transformationTypeSelector.append('<option value=\'' + this.editableMigration['type'] + '\'>' + this.editableMigration['type'] + '</option>')
		transformationTypeSelector.val(this.editableMigration['type'])
		transformationTypeSelector.addClass('def-val')

		if (this.editableMigration['type'] === 'EXCEL') {
			this.renderImportExcelTemplate()
		}
		if (this.editableMigration['type'] === 'XML') {
			this.renderImportXmlTemplate()
		}
		if (this.editableMigration['type'] === 'CSV') {
			this.renderImportCsvTemplate()
		}
		if (this.editableMigration['type'] === 'ZIP_ATTACHMENT') {
			this.renderImportZipTemplate()
		}
	}

	this.getEditMigrationParameters = function () {
		this.migrationConfig['id'] = this.editableMigration['id']
		this.migrationConfig['name'] = $('#migration-name').val()
		this.migrationConfig['type'] = this.editableMigration['type']
		this.migrationConfig['companyId'] = companyId
		this.migrationConfig['action'] = $('#migration-action').val()

		var params = {
			importSample: nullOnEmpty($('#import-sample').val()),
			debug: getDataFromBoolean('debug-mode'),
			updateNullFieldsOnly: getDataFromBoolean('update-null-fields-only')
		}
		if (this.editableMigration['type'] === 'XML') {
			addXsltParamAsArrayIfDefined(params, $('#xslt-file').val())
		} else if (this.editableMigration['type'] === 'EXCEL') {
			addXsltParamAsArrayIfDefined(params, $('#xslt-file').val())
		} else if (this.editableMigration['type'] === 'CSV') {
			addXsltParamAsArrayIfDefined(params, $('#xslt-file').val())

			params.encoding = $('#string-value-1').val()
			params.csvFormat = $('#csv-format-list').val()
		} else if (this.editableMigration['type'] === 'ZIP_ATTACHMENT') {
			params.fileNameTokenDelimiter = $('#string-value-1').val()
			params.hashCodeDelimiter = $('#string-value-2').val()
		}
		this.migrationConfig.parameters = params

		function addXsltParamAsArrayIfDefined (params, xslt) {
			if (xslt) {
				params.xslt = [xslt]
			}
		}

		function nullOnEmpty (value) {
			return value !== '' ? value : null
		}
	}

	this.deleteMigration = function (migration, table) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('delete') + ' ' + migration['name'] + '?',
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				var prefix = manager.global ? 'global/' : ''
				var url = prefix + 'import-config/' + migration['id'] + '/delete'
				$.ajax({
					url: window.urlContext + url,
					type: 'POST',
					async: false,
					success: function () {
						table.initTable()
						showMessageAlert(getLocalizedMessage('success'), 'success')
					},
					error: function (response) {
						if (response.status === 409) {
							showMessageAlert(getLocalizedMessage('unresolved.references.exist'), 'danger')
						} else {
							showMessageAlert(getLocalizedMessage('error'), 'danger')
						}
					}
				})
			}
		})
	}

	this.updateMigration = function (table) {
		var prefix = this.global ? 'global/' : ''
		var url = prefix + 'import-config/' + this.migrationConfig['id'] + '/save'
		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			async: true,
			context: this,
			contentType: 'application/json; charset=UTF-8',
			data: JSON.stringify(this.migrationConfig),
			success: function () {
				table.initTable()
				showMessageAlert(getLocalizedMessage('success'), 'success');
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error'), 'danger');
			}
		});
	};
}
